module.exports = __webpack_public_path__ + "img/coins-balance-paytype.eaae02cd.png";